import { subscribe } from '../../common/errors/sagas';
import { subscribeConfiguration } from '../../common/saveconfiguration/sagas';
import { notificationError, notificationInfo } from '../../common/errors/notificationTypes';

const pre = 'IMPACTANALYSIS/SUMMARY/';

export const IMPACT_ANALYSIS_LOADED = `${pre}IMPACT_ANALYSIS_LOADING`;
export const SET_DEFAULT_FILTERS = `${pre}SET_DEFAULT_FILTERS`;
export const SET_LOADING = `${pre}SET_LOADING`;
export const SET_INITIALISED = `${pre}SET_INITIALISED`;
export const SET_SUMMARY_INFO_STATS = `${pre}SET_SUMMARY_INFO_STATS`;
export const SET_SUMMARY_INFO_LOADED = `${pre}SET_SUMMARY_INFO_LOADED`;
export const FETCH_SUMMARY_INFO_STATS_FAILED = `${pre}FETCH_SUMMARY_INFO_STATS_FAILED`;
export const SET_CURRENCY_TO_SHOW = `${pre}SET_CURRENCY_TO_SHOW`;
export const SET_SUMMARY_GRID_ROWS = `${pre}SET_SUMMARY_GRID_ROWS`;
export const SHOW_CSA_SUMMARY = `${pre}SHOW_CSA_SUMMARY`;
export const SET_DEFAULT_CONFIG = `${pre}SET_DEFAULT_CONFIG`;
export const SET_SHOW_DEFAULT_MAPPINGS = `${pre}SET_SHOW_DEFAULT_MAPPINGS`;
export const FETCH_DEFAULT_CONFIG_FAILED = `${pre}FETCH_DEFAULT_CONFIG_FAILED`;
export const SET_CURRENT_CSA_STATUS = `${pre}SET_CURRENT_CSA_STATUS`;
export const SET_CURRENT_CSA_TYPE = `${pre}SET_CURRENT_CSA_TYPE`;
export const COPY_TRANSACTION_ID = `${pre}COPY_TRANSACTION_ID`;
export const SET_TRANSACTION_ID = `${pre}SET_TRANSACTION_ID`;

subscribe(FETCH_SUMMARY_INFO_STATS_FAILED, 'Failed to fetch Summary Info', notificationError);
subscribe(FETCH_DEFAULT_CONFIG_FAILED, 'Failed to fetch the default configuration', notificationError);
subscribe(COPY_TRANSACTION_ID, 'Copied ID', notificationInfo);
subscribeConfiguration(SET_CURRENCY_TO_SHOW, 'ImpactAnalysis');
subscribeConfiguration(SHOW_CSA_SUMMARY, 'ImpactAnalysis');
subscribeConfiguration(SET_SHOW_DEFAULT_MAPPINGS, 'ImpactAnalysis');

export const setShowDefaultMappings = shouldShow => ({
    type: SET_SHOW_DEFAULT_MAPPINGS,
    shouldShow
});

export const setDefaultConfig = (currency, showCsaSummary, showDefaultMappings) => ({
    type: SET_DEFAULT_CONFIG,
    currency,
    showCsaSummary,
    showDefaultMappings
});

export const setShowCsaSummary = shouldShow => ({
    type: SHOW_CSA_SUMMARY,
    shouldShow
});

export const setSummaryGridRows = rows => ({
    type: SET_SUMMARY_GRID_ROWS,
    rows
});

export const setCurrencyToShow = currency => ({
    type: SET_CURRENCY_TO_SHOW,
    currency
});

export const setSummaryInfoLoaded = loaded => ({
    type: SET_SUMMARY_INFO_LOADED,
    loaded
});

export const impactAnalysisLoaded = () => ({
    type: IMPACT_ANALYSIS_LOADED
});

export const setDefaultFilters = filters => ({
    type: SET_DEFAULT_FILTERS,
    filters
});

export const setInitialised = initialised => ({
    type: SET_INITIALISED,
    initialised
});


export const setLoading = loading => ({
    type: SET_LOADING,
    loading
});

export const setSummaryInfoStats = (stats, serverFilters) => ({
    type: SET_SUMMARY_INFO_STATS,
    stats,
    serverFilters
});

export const fetchSummaryInfoStatsFailed = error => ({
    type: FETCH_SUMMARY_INFO_STATS_FAILED,
    error
});

export const fetchDefaultConfigFailed = error => ({
    type: FETCH_DEFAULT_CONFIG_FAILED,
    error
});

export const setCurrentCsaStatus = status => ({
    type: SET_CURRENT_CSA_STATUS,
    status
});

export const setCurrentCsaType = csaType => ({
    type: SET_CURRENT_CSA_TYPE,
    csaType
});

export const setTransactionId = id => ({
    type: SET_TRANSACTION_ID,
    id
});

export const copyTransactionId = error => ({
    type: COPY_TRANSACTION_ID,
    error
});
